import {WalletContext} from '#/contexts/wallet-provider';
import {ERC20Contract} from '#/contracts/ERC20Contract';
import environment from '#/environment/environment';
import {useContext} from 'react';

export const useERC20Contract = (): ERC20Contract | null => {
  const {
    accountResult: {address},
  } = useContext(WalletContext);

  if (!address) {
    return null;
  }

  return new ERC20Contract(address, environment.stableTokenAddress);
};

export default useERC20Contract;
